import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { useStyles } from './LocationCard.styles'
import { LocationIcon } from '../SVGIcons'
import Link from '../Link'

const LocationCard = ({ name, openingTime, location, address, t }) => {
  const styles = useStyles()
  return (
    <Box xs={12} md={3} className={styles.root}>
      <Box className={styles.iconWrapper}>
        <LocationIcon />
      </Box>
      <Box className={styles.textWrapper}>
        <Box>
          <Typography
            variant="body2"
            className={`${styles.text} ${styles.bold}`}
          >
            {name}
          </Typography>
          <Typography variant="body2" className={styles.text}>
            <span>{address}</span>
          </Typography>
        </Box>
        <Box>
          <Typography
            variant="body2"
            className={`${styles.text} ${styles.greyText}`}
          >
            {openingTime}
          </Typography>
          {location && (
            <Typography variant="body2" className={styles.text}>
              <Link to={location} isExternal>
                {t('View on Map')}
              </Link>
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  )
}
export default LocationCard
